const ChevronDownIcon = () => {
    return (
        <img
            style={{ width: '100%', height: '100%' }}
            src="/images/chevron-down-icon.svg"
            alt="Document Icon"
        />
    );
};

export default ChevronDownIcon;
